import {
  Flex,
  Modal,
  MODAL_SIZE_LG,
  ModalBody,
  ModalFoot,
  ModalHead
} from 'mailup-web-components'
import PropTypes from 'prop-types'

import ErrorFeedback from 'Components/ErrorFeedback'
import useModalSmsMessages from 'Hooks/useModalSmsMessages/useModalSmsMessages'
import { useIntl } from 'react-intl'
import HeaderMessageBox from './components/HeaderMessageBox'
import Search from './components/Search'
import TableMessages from './components/TableMessages'

const ModalSmsMessages = ({ handleCancel, handleConfirm }) => {
  const intl = useIntl()
  const { show, items, loaded, error, errMessage, severity } =
    useModalSmsMessages()

  return (
    <>
      <Modal
        data-mu-test='modal-sms-messages'
        show={show}
        showClose
        onClose={handleCancel}
        closeOnOverlayClick
        size={MODAL_SIZE_LG}
      >
        <ModalHead
          title={intl.formatMessage({
            id: 'Load.SelectEmailMessage.Title'
          })}
        />
        <ModalBody scrollable>
          <Flex height='450px' flexDirection='column' rowGap='24px'>
            <ErrorFeedback error={errMessage} severity={severity} />
            {!error && loaded && (
              <>
                <HeaderMessageBox />
                <Search />
                <TableMessages items={items} handleConfirm={handleConfirm} />
              </>
            )}
          </Flex>
        </ModalBody>
        <ModalFoot />
      </Modal>
    </>
  )
}

ModalSmsMessages.propTypes = {
  handleCancel: PropTypes.func,
  handleConfirm: PropTypes.func
}

export default ModalSmsMessages
